import { gql } from "@apollo/client";

export const UPDATE_MY_PROFILE_MUTATION = gql`
  mutation UpdateMyProfile($profileData: ProfileInput!) {
    updateMyProfile(profileData: $profileData) {
      client {
        id
        name
        surname
      }
    }
  }
`;
